<template>
    <div>
        <div name="table-list" class="table-layout" v-if="paramMap != null">
            <swb-easy-report-table ref="swb_easy_report_table" :rowNoShow="true" :confKey="confKey" :configAuto="configAuto" :reportName="reportName" :reportCode="reportCode" :paramMap="paramMap" :paramKeys="paramKeys" :hideParamKeys="hideParamKeys" :showStatColumns="false" :queryData="queryData" :domHeight="domHeight" :showExport="false"></swb-easy-report-table>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'

    import easyReportApi from '../../api/easyReport'

    import SwbEasyReport from './EasyReport'
    Vue.regist(SwbEasyReport);

    export default {
        name: 'swb-servc-work-voucher-ds-assign-shop-select',
        desc: '工单指派调度策略【指派网点】',
        props: ['merchantId', 'comId', 'comLevel', 'voucherId', 'buyerShopLat', 'buyerShopLng', 'servcId', 'servcType', 'buyerShopId', 'devcCatId', 'servcCatId'],
        data: function () {
            return {
                confKey: 'swb-servc-work-voucher-ds-assign-shop-select',
                configAuto: true,
                reportCode: "servc_work_voucher_dispatch_strategy_assign_shop",
                reportName: "工单指派调度策略【指派网点】",
                domHeight: 550,
                //
                paramMap: null,
                paramKeys: [],
                hideParamKeys: ["servicerId", "servicerIdX", "cxtMerchantId", "cxtMerchantIdX", "voucherId", "comId", "comLevel", 'buyerShopLat', 'buyerShopLng', 'servcId', 'servcType', 'buyerShopId', 'devcCatId', 'servcCatId'],
                queryData: true,
            }
        },
        created: function () {
            if(this.voucherId != null) {
                let paramMap = {
                    voucherId: this.voucherId,
                    comId: this.comId,
                    comLevel: this.comLevel,
                    includeSubComs: true
                };
                this.paramMap = Utils.merge({}, paramMap);
            } else {
                let paramMap = {
                    servicerIdX: this.merchantId,
                    comId: this.comId,
                    comLevel: this.comLevel,
                    includeSubComs: true,
                    buyerShopLat: this.buyerShopLat,
                    buyerShopLng: this.buyerShopLng,
                    servcId: this.servcId,
                    servcType: this.servcType,
                    buyerShopId: this.buyerShopId,
                    devcCatId: this.devcCatId,
                    servcCatId: this.servcCatId
                };
                this.reportCode = 'servc_work_voucher_dispatch_strategy_assign_shop_two';
                this.paramMap = Utils.merge({}, paramMap);
            }
        },
        methods: {
            getDlgResult(){
                return this.$refs.swb_easy_report_table.getTableSelection();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/easyReport/ServcWorkVoucherDsAssignShopSelect.vue